/* eslint-disable no-unused-vars */
// @ts-nocheck
import React, { useEffect, useCallback } from 'react';
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  useTheme,
} from '@mui/material';
import { ReactComponent as NimbusUnoLogo } from '../../assets/images/NimbusUnoLogo.svg';
import { ReactComponent as MRMVaultLogo } from '../../assets/images/MRMVaultLogo.svg';
import useAuth from '../../Hooks/Auth/useAuth';
import { ReactComponent as ApplicationIcon } from '../../assets/images/ApplicationIcon.svg';
import SwalToast from '../../components/Common/SwalToast';

function ApplicationLauncher() {
  const themes = useTheme();
  const { user } = useAuth();
  const [integrationUrls, setIntegrationUrls] = React.useState([]);

  React.useEffect(() => {
    const fetchIntegrations = async () => {
      try {
        const realmConfig = JSON.parse(localStorage.getItem('REALM_CONFIG'));
        setIntegrationUrls(realmConfig?.integrationsUrls);
      } catch (error) {
        SwalToast({
          icon: 'error',
          title: `Please provide valid organization name.`,
        });
      }
    };

    setTimeout(() => {
      fetchIntegrations();
    }, 2000); // Simulate a delay of 2 second before fetching integrations
  }, []);

  const applications = React.useMemo(
    () => [
      {
        name: 'NIMBUS UNO',
        logo: <NimbusUnoLogo width={175} height={128} />,
        url: '/project/overview',
      },
      {
        name: 'MRM VAULT',
        logo: <MRMVaultLogo width={175} height={128} />,
        url: `${integrationUrls?.vault}?org=${localStorage.getItem('REALM_ID')}&fromLauncher=true`,
      },
      // Add more applications here as needed
    ],
    [integrationUrls]
  );

  const handleApplicationClick = (app) => {
    const realmId = localStorage.getItem('REALM_ID');
    if (app?.url) {
      if (app?.name === 'NIMBUS UNO') {
        if (realmId) {
          window.open('/project/overview?fromLauncher=true', '_blank');
        } else {
          window.open('/org?fromLauncher=true', '_blank');
        }
      } else {
        window.open(`${app?.url}?org=${realmId}`, '_blank');
      }
    }
  };
  useEffect(() => {
    if (user.isAuthenticate) {
      window.location.href = '/project/overview?fromLauncher=true';
    }
  }, [user?.isAuthenticate]);
  const appBarSx = useCallback(
    (theme) => ({
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: theme.palette.other.white,
    }),
    []
  );
  return (
    <>
      <AppBar position="absolute" sx={appBarSx} elevation={2}>
        <Toolbar>
          <ApplicationIcon
            style={{
              color: themes.palette.primary.main,
              width: 24,
              height: 24,
            }}
          />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1 }}
            ml={1}
            title="App Launcher"
            aria-label="App Launcher"
          >
            App Launcher
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        height="100vh"
        sx={(theme) => ({
          backgroundColor: theme.palette.background.default,
        })}
      >
        <Grid item alignItems="center" textAlign="center" mb={4}>
          <Typography
            variant="h1"
            mb={3}
            title="Welcome to the Model Risk Ecosystem"
            aria-label="Welcome to the Model Risk Ecosystem"
          >
            Welcome to the Model Risk Ecosystem
          </Typography>
          <Typography
            variant="h4"
            title="Please select a platform to continue"
            aria-label="Please select a platform to continue"
          >
            Please select a platform to continue
          </Typography>

          <Card
            sx={(theme) => ({
              width: '700px',
              backgroundColor: '#AECDFC',
              padding: theme.spacing(4),
              marginTop: theme.spacing(4),
              overflow: 'scroll',
              flexWrap: 'wrap',
            })}
          >
            <CardContent
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-evenly',
                paddingBottom: '0 !important',
              }}
            >
              {applications.map(
                (app) =>
                  !app?.hide && (
                    <Card
                      key={app?.name}
                      onClick={() => handleApplicationClick(app)}
                      sx={{
                        width: 230,
                        height: 202,
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                          transform: 'scale(1.08)',
                        },
                      }}
                    >
                      <CardContent
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 175,
                            height: 128,
                            padding: 1,
                          }}
                        >
                          {app?.logo}
                        </Box>
                        <Typography
                          variant="h4"
                          title={app?.name}
                          aria-label={app?.name}
                        >
                          {app?.name}
                        </Typography>
                      </CardContent>
                    </Card>
                  )
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default ApplicationLauncher;
